export const types = {
    SET_LAYOUT_SCOPES: "layout/SET_LAYOUT_SCOPES",
    SET_LAYOUT_TITLE_KEY: "layout/SET_LAYOUT_TITLE_KEY",
    SET_LAYOUT_HEADER_TITLE: "layout/SET_LAYOUT_HEADER_TITLE",
    SET_LAYOUT_HEADER_SUBTITLE: "layout/SET_LAYOUT_HEADER_SUBTITLE",
    SET_LAYOUT_HEADER_SUBTITLE_ELEMENT: "layout/SET_LAYOUT_HEADER_SUBTITLE_ELEMENT",
    SET_LAYOUT_RIGHT_CONTENT_MOBILE: "layout/SET_LAYOUT_RIGHT_CONTENT_MOBILE",
    SET_GO_BACK_PATH: "layout/SET_GO_BACK_PATH",
    SET_GO_BACK_HANDLER: "layout/SET_GO_BACK_HANDLER",
};

export const INITIAL_STATE = {
    scopes: [],
    titleKey: "",
    headerTitle: "",
    headerSubtitle: "",
    headerSubtitleElement: null,
    rightContentMobile: null,
    goBackPath: null,
    goBackHandler: null,
};

export default (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case types.SET_LAYOUT_SCOPES:
            return {
                ...state,
                scopes: action.scopes ?? [],
            };
        case types.SET_LAYOUT_TITLE_KEY: {
            const titleKey = action.titleKey ?? "";
            return {
                ...state,
                titleKey,
                ...(titleKey ? { headerTitle: "", headerSubtitle: "", headerSubtitleElement: null } : {}),
            };
        }
        case types.SET_LAYOUT_HEADER_TITLE: {
            const headerTitle = action.headerTitle ?? "";
            return {
                ...state,
                headerTitle,
                ...(headerTitle ? { titleKey: "" } : {}),
            };
        }
        case types.SET_LAYOUT_HEADER_SUBTITLE:
            return {
                ...state,
                headerSubtitle: action.headerSubtitle ?? "",
                ...(action.headerSubtitle ? {} : { headerSubtitleElement: null }),
            };
        case types.SET_LAYOUT_HEADER_SUBTITLE_ELEMENT:
            return {
                ...state,
                headerSubtitleElement: action.headerSubtitleElement ?? null,
            };
        case types.SET_LAYOUT_RIGHT_CONTENT_MOBILE:
            return {
                ...state,
                rightContentMobile: action.rightContentMobile ?? null,
            };
        case types.SET_GO_BACK_PATH:
            return {
                ...state,
                goBackPath: action.goBackPath ?? null,
            };
        case types.SET_GO_BACK_HANDLER:
            return {
                ...state,
                goBackHandler: action.goBackHandler ?? null,
            };
        default:
            return state;
    }
};

// Action creators
export const actions = {
    setScopes: (scopes) => ({
        type: types.SET_LAYOUT_SCOPES,
        scopes: Array.isArray(scopes) ? scopes : [scopes],
    }),
    setTitleKey: (titleKey) => ({
        type: types.SET_LAYOUT_TITLE_KEY,
        titleKey,
    }),
    setHeaderTitle: (headerTitle) => ({
        type: types.SET_LAYOUT_HEADER_TITLE,
        headerTitle,
    }),
    setHeaderSubtitle: (headerSubtitle) => ({
        type: types.SET_LAYOUT_HEADER_SUBTITLE,
        headerSubtitle,
    }),
    setHeaderSubtitleElement: (headerSubtitleElement) => ({
        type: types.SET_LAYOUT_HEADER_SUBTITLE_ELEMENT,
        headerSubtitleElement,
    }),
    setRightContentMobile: (rightContentMobile) => ({
        type: types.SET_LAYOUT_RIGHT_CONTENT_MOBILE,
        rightContentMobile,
    }),
    setGoBackPath: (goBackPath) => ({
        type: types.SET_GO_BACK_PATH,
        goBackPath,
    }),
    setGoBackHandler: (goBackHandler) => ({
        type: types.SET_GO_BACK_HANDLER,
        goBackHandler,
    }),
};

export const selectors = {
    getScopes: (state) => state.layout?.scopes ?? [],
    getTitleKey: (state) => state.layout?.titleKey ?? "",
    getHeaderTitle: (state) => state.layout?.headerTitle ?? "",
    getHeaderSubtitle: (state) => state.layout?.headerSubtitle ?? "",
    getHeaderSubtitleElement: (state) => state.layout?.headerSubtitleElement ?? null,
    getRightContentMobile: (state) => state.layout?.rightContentMobile ?? null,
    getGoBackPath: (state) => state.layout?.goBackPath ?? null,
    getGoBackHandler: (state) => state.layout?.goBackHandler ?? null,
};
